import React from 'react';
import { useController } from 'react-hook-form';
import {
  FormInputLabel,
  FormItemContainer,
  FormTextArea,
} from '../StyledComponents';
import Grid from '@material-ui/core/Grid';

const TextArea = ({
  name,
  control,
  rules,
  label,
  placeholder,
  style,
  disabled,
  onChangeDefault,
  onPress,
  notRequired = false,
  requiredColor = '#0061C6',
  maxLength = 140,
  showMaxLengthLabel = false,
  borderRadius = '',
  ...props
}) => {
  const {
    field: { value, onChange },
    fieldState: { error },
  } = useController({ control, name, rules });

  const renderError = () =>
    error && error.message ? (
      <p
        style={{
          color: error?.message ? '#F5365C' : '#000000',
        }}
      >
        {error?.message}
      </p>
    ) : null;

  return (
    <FormItemContainer>
      <FormInputLabel>
        <label>
          {label ?? placeholder}{' '}
          {!notRequired && <strong style={{ color: requiredColor }}>*</strong>}
        </label>
      </FormInputLabel>
      <FormTextArea
        {...props}
        value={value}
        placeholder={placeholder}
        onChange={(event) => {
          if (onChangeDefault) onChangeDefault(event.target.value);
          onChange(event.target.value);
        }}
        maxLength={maxLength}
        borderRadius={borderRadius}
      />
      {!!showMaxLengthLabel && (
        <Grid item container flexDirection={'row'}>
          <Grid item md={10}>
            <>{renderError()}</>
          </Grid>
          <Grid
            item
            md={2}
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              paddingRight: '10px',
            }}
          >
            <FormInputLabel>{`${
              value?.toString()?.length ?? 0
            }/${maxLength}`}</FormInputLabel>
          </Grid>
        </Grid>
      )}
    </FormItemContainer>
  );
};

export default TextArea;
